module.exports = __webpack_public_path__ + "img/meauicon4.f0fa3df2.svg";